import React, { useState } from 'react';

import RequestPasswordReset from './RequestPasswordReset';
import RequestPasswordResetFail from './RequestPasswordResetFail';
import RequestPasswordResetSuccess from './RequestPasswordResetSuccess';
import { SkinTheme } from '../../design/models/SkinTheme';
import { SkinThemeConsumer } from '../../shared/SkinThemeContext';

const RequestPasswordResetContainer = () => {
  const [emailSent, setEmailSent] = useState<boolean>();
  const [email, setEmail] = useState('');
  const [linkedAccount, setLinkedAccount] = useState<boolean>();
  const [parentFullName, setParentFullName] = useState('');

  return (
    <SkinThemeConsumer>
    {
      (themeOptions: SkinTheme) => (
        <div className="membership-content">
        {
          emailSent === undefined
          &&
          <RequestPasswordReset
            onEmailSent={ (success, email, linkedAccount, parentFullName) => {
              setEmailSent(success);
              setEmail(email);
              setLinkedAccount(linkedAccount);
              setParentFullName(parentFullName);
            } }
          />
        }
        {
          emailSent === true
          &&
          <RequestPasswordResetSuccess
            email={email}
            linkedAccount={linkedAccount}
            parentFullName={parentFullName}
          />
        }
        {
          emailSent === false
          &&
          <RequestPasswordResetFail />
        }
        </div>
      )
    }
    </SkinThemeConsumer>
  )
}

export default RequestPasswordResetContainer;
